// constants.ts
export const colCountGlobal = 12; // col size related to parent width
export const rowSizeGlobal = 16; // row size related to parent height